import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import {
    FETCH_DECORATION_METHODS,
    SET_DECORATION_METHOD_NAME
} from "./actions.type";
import {
    FETCH_DECORATIONS_START,
    FETCH_DECORATIONS_END,
    SET_DECORATION_METHOD_NAME_MUTATION
} from "./mutations.type";

const state = {
    decorationMethods: [],
    isLoading: true
};

const getters = {
    decorationMethods(state) {
        return state.decorationMethods;
    },
    getDecorationMethodName(decorationType) {
        const decorationMethod = state.decorationMethods.filter(
            (method) => method.id == decorationType
        );
        if (decorationMethod) {
            return decorationMethod.name;
        }
        return "";
    },
    activeDecorationMethods(state) {
        return state.decorationMethods.filter((method) => method.status);
    },
    isLoadings(state) {
        return state.isLoading;
    }
};

const actions = {
    [FETCH_DECORATION_METHODS]({ commit }) {
        if (!JwtService.getToken()) return false;
        commit(FETCH_DECORATIONS_START);
        return ApiService.get("/decoration-methods")
            .then(({ data }) => {
                commit(FETCH_DECORATIONS_END, data);
            })
            .catch((error) => {
                throw new Error(error);
            });
    },
    [SET_DECORATION_METHOD_NAME]({ commit }, params) {
        commit(SET_DECORATION_METHOD_NAME_MUTATION, params);
    }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [FETCH_DECORATIONS_START](state) {
        state.isLoading = true;
    },
    [FETCH_DECORATIONS_END](state, { decoration_methods }) {
        state.decorationMethods = decoration_methods;
        state.isLoading = false;
    },
    [SET_DECORATION_METHOD_NAME_MUTATION](state, { id, name }) {
        let decoration_index = state.decorationMethods.findIndex(
            (dec) => dec.id == id
        );
        state.decorationMethods[decoration_index]["name"] = name;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
